import React from 'react'
import { Tooltip } from '@/components/ui/tooltip'

export default ({ label, content, children }) => {
  return <Tooltip content={content || label} openDelay={50} showArrow>{children}</Tooltip>
}
